module.exports = __webpack_public_path__ + "static/f1-d86893c352336e7be09ce074560bb544.png";